export default {
  buttons: {
    signup: 'Aanmelden',
    login: 'Inloggen',
  },
};
